module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/OrangeTimer/images/timer-glow-big.24229aba.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/OrangeTimer/images/timer-glow-big.png
// module id = 2942
// module chunks = 11